import { useQuery } from '@tanstack/react-query';

import { getAddressByZipCode } from 'services';

export const useAddressByZipcode = (zipcode: string, enabled: boolean) => {
  return {
    ...useQuery({
      queryKey: [zipcode],
      queryFn: getAddressByZipCode,
      staleTime: 2 * 60 * 1000,
      refetchOnWindowFocus: false,
      enabled,
    }),
  };
};
